"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontOverrides = void 0;
exports.fontOverrides = {
    'Puffin Display Soft': {
        fontFamily: 'puffin-display-soft',
        fontLocation: 'https://use.typekit.net/hai1juy.css',
    },
};
//# sourceMappingURL=index.js.map